<template>
  <div>
    <ModalCreate
      ref="modalCreate"
      :product-id="packageId"
      :submitting="submitting"
      @submit="doStorePackageItem"
    />
  </div>
</template>

<script>
import ModalCreate from '@/components/PackageItem/ModalCreate.vue';
import { packageItemMethods } from '@/store/adminHelper';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';

export default {
  name: 'PackageItemCreate',
  mixins: [veeValidateErrorsMixin],
  components: {
    ModalCreate,
  },
  props: {
    packageId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    submitting: false,
    scope: 'packageItemCreate',
  }),
  methods: {
    ...packageItemMethods,
    doStorePackageItem({ postData, next }) {
      const { packageId } = this;
      this.submitting = true;
      this.storePackageItem({ packageId, postData })
        .then(() => {
          this.submitting = false;
          next();
        })
        .catch(({ status = null, data = {} } = {}) => {
          if (status === HTTP_UNPROCESSABLE_ENTITY) {
            this.observer = this.$refs.modalCreate.$refs.observer;
            this.addServerErrors(data.errors);
          }
          this.submitting = false;
        });
    },
  },
};
</script>
